"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  _apollo: true,
  _locale: true,
  _country: true,
  init: true
};
exports._locale = exports._country = exports._apollo = void 0;
exports.init = init;

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var currency = _interopRequireWildcard(require("./currency"));

Object.keys(currency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === currency[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return currency[key];
    }
  });
});

var date = _interopRequireWildcard(require("./date"));

Object.keys(date).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === date[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return date[key];
    }
  });
});

var distance = _interopRequireWildcard(require("./distance"));

Object.keys(distance).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === distance[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return distance[key];
    }
  });
});

var phone = _interopRequireWildcard(require("./phone"));

Object.keys(phone).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === phone[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return phone[key];
    }
  });
});

var _common = require("./common");

Object.keys(_common).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _common[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _common[key];
    }
  });
});

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _inited;

var _apollo;

exports._apollo = _apollo;

var _locale;

exports._locale = _locale;

var _country; // 用户传入的locale不是elvish支持的locale时，自动匹配为elvish支持的对应国家的locale
// eg. en-CL会转换为es-CL


exports._country = _country;

function getSupportedLocale() {
  var cou = _locale.split('-')[1]; // 当传入错误的locale找不到对应的国家和语言时，就返回用户传入的locale


  exports._locale = _locale = _apollo.countryBaseInfo[cou] ? "".concat(_apollo.countryBaseInfo[cou].lang.split(',')[0], "-").concat(cou) : _locale;
} // 拉取apollo配置并缓存到lcoalStorage


function getFromApollo() {
  return (0, _isomorphicFetch["default"])("https://static.didiglobal.com/ibt/elvish/apollo.json").then(function (res) {
    return res.json();
  }).then(function (config) {
    exports._apollo = _apollo = config;
    typeof window !== "undefined" && window.localStorage && window.localStorage.setItem('elvishConfig', JSON.stringify(config));
  })["catch"](function (err) {
    // 如果拉取apollo配置失败，如果storage里有缓存，就取storage的缓存
    console.warn('Elvish Warning: require apollo config error');

    if (typeof window !== "undefined" && window.localStorage && window.localStorage.getItem('elvishConfig')) {
      try {
        exports._apollo = _apollo = JSON.parse(window.localStorage.getItem('elvishConfig') || '');
      } catch (e) {
        console.warn('Elvish Warning: JSON.parse error');
        throw Error('Elvish Fetch Error: 请求apollo配置出错且无缓存可用'); // return false;
      }
    } else {
      console.warn('Elvish Warning: no cache');
      throw Error('Elvish Fetch Error: 请求apollo配置出错且无缓存可用'); // return false;
    }
  });
}

function fetchApollo(config, ifCache) {
  if (_inited) return Promise.resolve();

  if (!config) {
    _inited = true; // node环境下不走缓存，直接去请求远程
    // 如果localStorage中有elvishConfig，且用户需要缓存，走缓存

    if (typeof window !== "undefined" && window.localStorage && window.localStorage.getItem('elvishConfig') && ifCache) {
      // 当JSON.parse报错时，直接请求Apollo配置
      try {
        exports._apollo = _apollo = JSON.parse(window.localStorage.getItem('elvishConfig') || '');
      } catch (e) {
        return getFromApollo();
      } // 从storage中取到缓存之后，从apollo取到最新配置更新到缓存


      (0, _isomorphicFetch["default"])("https://static.didiglobal.com/ibt/elvish/apollo.json").then(function (res) {
        return res.json();
      }).then(function (config) {
        window.localStorage.setItem('elvishConfig', JSON.stringify(config));
      })["catch"](function (err) {
        console.warn(err);
        console.warn('Elvish Warning: update apollo localStorage error');
      });
      return Promise.resolve();
    } else {
      return getFromApollo();
    }
  } else {
    exports._apollo = _apollo = config;
    return Promise.resolve();
  }
} // country, config, ifCache(默认为true)可选


function init(locale, country, config) {
  var ifCache = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (typeof country === 'boolean') {
    ifCache = country;
    country = undefined;
  }

  if (typeof config === 'boolean') {
    ifCache = config;
    config = undefined;
  }

  if (typeof country !== "string" && typeof country !== "boolean") {
    config = country;
    country = undefined;
  }

  if ((locale === "es_CO" || locale === "es-CO") && country === "CR") locale = "es_CR";
  if ((locale === "es_CO" || locale === "es-CO") && country === "PA") locale = "es_PA";
  if ((locale === "es_CO" || locale === "es-CO") && country === "DO") locale = "es_DO";
  exports._locale = _locale = (locale || "").replace("_", "-");
  exports._country = _country = country;
  return Promise.all([fetchApollo(config && config.apollo, ifCache), currency.init(config), date.init(config, ifCache), distance.init(config), phone.init(config, ifCache)]);
}